import { render, staticRenderFns } from "./AlertDetail.vue?vue&type=template&id=75314f2c&scoped=true&"
import script from "./AlertDetail.vue?vue&type=script&lang=js&"
export * from "./AlertDetail.vue?vue&type=script&lang=js&"
import style0 from "./AlertDetail.vue?vue&type=style&index=0&id=75314f2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75314f2c",
  null
  
)

export default component.exports